"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDatagrid = void 0;
var material_1 = require("@mui/material");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var SortArrayContext_1 = require("./SortArrayContext");
var CustomDatagridHeader = function (_a) {
    var children = _a.children, sortfields = _a.sortfields, setsortfields = _a.setsortfields, data = _a.data, selectedIds = _a.selectedIds, onSelect = _a.onSelect, isRowSelectable = _a.isRowSelectable;
    var setSort = (0, react_admin_1.useListContext)().setSort;
    var updateSortArray = (0, SortArrayContext_1.useSortArray)().updateSortArray;
    var handleHeaderClick = (0, react_1.useCallback)(function (field) {
        var currentIndex = sortfields.findIndex(function (sf) { return sf.field === field; });
        var newSortFields = __spreadArray([], sortfields, true);
        if (currentIndex === -1) {
            if (sortfields.length < 2) {
                newSortFields.push({ field: field, order: react_admin_1.SORT_ASC });
            }
            else
                return;
        }
        else {
            var currentOrder = sortfields[currentIndex].order;
            if (sortfields.length === 1) {
                newSortFields[currentIndex] = {
                    field: field,
                    order: currentOrder === react_admin_1.SORT_ASC ? react_admin_1.SORT_DESC : react_admin_1.SORT_ASC,
                };
            }
            else {
                if (currentOrder === react_admin_1.SORT_ASC) {
                    newSortFields[currentIndex] = { field: field, order: react_admin_1.SORT_DESC };
                }
                else {
                    newSortFields.splice(currentIndex, 1);
                }
            }
        }
        setsortfields(newSortFields);
        // Update sortArray and force new getList request by calling setSort.
        var sortArray = newSortFields.flatMap(function (sf) { return [sf.field, sf.order]; });
        updateSortArray(sortArray);
        setSort({ field: "id", order: react_admin_1.SORT_ASC });
    }, [sortfields, setsortfields, setSort, updateSortArray]);
    var getSortDirection = (0, react_1.useCallback)(function (field) {
        var sortField = sortfields.find(function (sf) { return sf.field === field; });
        return sortField ? (sortField.order === react_admin_1.SORT_ASC ? "asc" : "desc") : undefined;
    }, [sortfields]);
    var handleSelectAll = (0, react_1.useCallback)(function (event) {
        return onSelect(event.target.checked
            ? selectedIds.concat(data
                .filter(function (record) { return !selectedIds.includes(record.id); })
                .filter(function (record) {
                return isRowSelectable
                    ? isRowSelectable(record)
                    : true;
            })
                .map(function (record) { return record.id; }))
            : []);
    }, [data, onSelect, isRowSelectable, selectedIds]);
    var selectableIds = Array.isArray(data)
        ? isRowSelectable
            ? data
                .filter(function (record) { return isRowSelectable(record); })
                .map(function (record) { return record.id; })
            : data.map(function (record) { return record.id; })
        : [];
    return (react_1.default.createElement(material_1.TableHead, { className: "".concat(react_admin_1.DatagridClasses.thead) },
        react_1.default.createElement(material_1.TableRow, { className: (0, clsx_1.default)(react_admin_1.DatagridClasses.row, react_admin_1.DatagridClasses.headerRow) },
            react_1.default.createElement(material_1.TableCell, { padding: "checkbox", className: "".concat(react_admin_1.DatagridClasses.headerCell) },
                react_1.default.createElement(material_1.Checkbox, { checked: selectedIds.length > 0 &&
                        selectableIds.length > 0 &&
                        selectableIds.every(function (id) {
                            return selectedIds.includes(id);
                        }), onChange: handleSelectAll, color: "primary" })),
            react_1.default.Children.map(children, function (child) {
                var _a = child.props, source = _a.source, label = _a.label, sortBy = _a.sortBy, _b = _a.sortable, sortable = _b === void 0 ? true : _b;
                var direction = getSortDirection(sortBy || source);
                var isSorted = !!direction;
                return (react_1.default.createElement(material_1.TableCell, { key: source, className: (0, clsx_1.default)(react_admin_1.DatagridClasses.headerCell, "column-".concat(source)) }, sortable ? (react_1.default.createElement(material_1.TableSortLabel, { active: isSorted, direction: direction, sx: { "&:focus": { color: "var(--info-color)" } }, onClick: sortable ? function (e) {
                        e.stopPropagation();
                        handleHeaderClick(sortBy || source);
                    } : undefined }, label || source)) : (react_1.default.createElement("span", null, label || source))));
            }))));
};
var CustomDatagrid = function (props) {
    var children = props.children, sortfields = props.sortfields, setsortfields = props.setsortfields, sx = props.sx, hover = props.hover, rowClick = props.rowClick, bulkActionButtons = props.bulkActionButtons;
    var _a = (0, react_admin_1.useListContext)(), data = _a.data, isLoading = _a.isLoading, selectedIds = _a.selectedIds, onToggleItem = _a.onToggleItem, onSelect = _a.onSelect, resource = _a.resource;
    var handleRowClick = function (id, record) {
        if (typeof rowClick === "function")
            rowClick(id, resource, record);
    };
    if (isLoading)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        bulkActionButtons && react_1.default.cloneElement(bulkActionButtons, { selectedIds: selectedIds }),
        react_1.default.createElement(material_1.Table, { sx: sx, size: "small" },
            react_1.default.createElement(CustomDatagridHeader, { sortfields: sortfields, setsortfields: setsortfields, data: data, selectedIds: selectedIds, onSelect: onSelect }, children),
            react_1.default.createElement(material_1.TableBody, { className: "datagrid-body ".concat(react_admin_1.DatagridClasses.tbody) }, data.map(function (record, rowIndex) {
                var _a;
                return (react_1.default.createElement(material_1.TableRow, { key: record.id, onClick: function () { return handleRowClick(record.id, record); }, className: (0, clsx_1.default)(react_admin_1.DatagridClasses.row, (_a = {},
                        _a[react_admin_1.DatagridClasses.rowEven] = rowIndex % 2 === 0,
                        _a[react_admin_1.DatagridClasses.rowOdd] = rowIndex % 2 !== 0,
                        _a[react_admin_1.DatagridClasses.clickableRow] = typeof rowClick === "function" ? true : rowClick,
                        _a)), hover: hover },
                    react_1.default.createElement(material_1.TableCell, { padding: "checkbox", className: "".concat(react_admin_1.DatagridClasses.rowCell) },
                        react_1.default.createElement(material_1.Checkbox, { checked: selectedIds.includes(record.id), onChange: function () { return onToggleItem(record.id); }, onClick: function (e) { return e.stopPropagation(); } })),
                    react_1.default.Children.map(children, function (child) {
                        var source = child.props.source;
                        return (react_1.default.createElement(material_1.TableCell, { key: "".concat(record.id, "-").concat(source || "custom"), className: (0, clsx_1.default)(react_admin_1.DatagridClasses.rowCell, "column-".concat(source)) },
                            react_1.default.createElement(react_admin_1.RecordContextProvider, { value: record }, react_1.default.cloneElement(child, { record: record }))));
                    })));
            })))));
};
exports.CustomDatagrid = CustomDatagrid;
